"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgCamera = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M27 14a1 1 0 01.832.445L29.535 17H33a3 3 0 013 3v11a3 3 0 01-3 3H15a3 3 0 01-3-3V20a3 3 0 013-3h3.465l1.703-2.555A1 1 0 0121 14h6zm-.535 2h-4.93l-1.703 2.555A1 1 0 0119 19h-4a1 1 0 00-1 1v11a1 1 0 001 1h18a1 1 0 001-1V20a1 1 0 00-1-1h-4a1 1 0 01-.832-.445L26.465 16zM24 20a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z",
    id: "camera_svg__a"
  }));
};

var _default = SvgCamera;
exports.default = _default;